import { Component, inject, signal } from '@angular/core'
import {
    AbstractControl,
    FormBuilder,
    ReactiveFormsModule,
    Validators
} from "@angular/forms"
import { errorTailorImports } from "@ngneat/error-tailor"
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"
import {
    PasswordStrengthBarComponent
} from "@app/components/password-strength-bar.component"
import { UserService } from "@/app/pages/principal/users/user.service"
import { finalize } from "rxjs"
import { alertNotification } from "@/app/utils/util"
import Swal from "sweetalert2"
import { Router } from "@angular/router"

@Component({
    selector: 'app-reset-password',
    imports: [
        ReactiveFormsModule,
        errorTailorImports,
        PasswordStrengthBarComponent
    ],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
    submitted = signal<boolean>(false)
    private fb = inject(FormBuilder)
    protected activeModal=inject(NgbActiveModal)
    private userService=inject(UserService)
    private router=inject(Router)
    passwordsMatch (control: AbstractControl) {
        const newPassword = control.get('newPassword')?.value
        const confirmPassword = control.get('confirmPassword')?.value
        return newPassword === confirmPassword ? null : { mismatch: true }
    }

    form = this.fb.group(
        {
            currentPassword: ['', Validators.required],
            newPassword: ['', [Validators.required, Validators.minLength(8)]],
            confirmPassword: ['', Validators.required]
        },
        { validators: this.passwordsMatch }
    )

    protected onSubmit () {
        if(this.form.invalid){
            this.form.markAsTouched();
            return
        }
        this.submitted.set(true)
        this.userService.changePassword({
            password: this.form.value.newPassword,
            password_confirmation: this.form.value.confirmPassword,
            current_password: this.form.value.currentPassword
        }).pipe(
            finalize(() => {
                this.submitted.set(false)
            })
        ).subscribe((rs)=>{
            Swal.fire({
                title: 'Contraseña cambiada correctamente ¿Desea volver a iniciar sesión?',
                icon: "success",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.activeModal.close(true);
                }else{
                    this.activeModal.close(false);
                }

            })

        })
    }
}
